module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAGCAYAAAC4s3xRAAAAAXNSR0IArs4c6QAAAFNJREFUOE/V07ERQEAUBNB3iZz6qEGkCCR6UB9K+OYCAhq42wre7OymiGiwokenzFzYMaWI2DCW6fyp5gw+Cm72Kz6rBNc0iSU3/JxuQFvolt/T3dNeHuzzejr0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/close_mobile.png
// module id = Vxyf
// module chunks = 1